import Api from '../Api';

import { url } from './config';
import { SupplierApplyBankTransferChargeOption } from './types';

const api = new Api<SupplierApplyBankTransferChargeOption>(url);

export default api;
